module.exports = __webpack_public_path__ + "img/product-feature-txt-bg2.dd1e568c.png";